import LineChart from './line-chart';
import DonutChart from './donut-chart';
import BarChart from './bar-chart';
import ProgressBar from './progress';

export default function Charts() {}

Charts.LineChart = LineChart;
Charts.DonutChart = DonutChart;
Charts.BarChart = BarChart;
Charts.ProgressBar = ProgressBar;
